import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup } from "aible";

import RunFrontierContainer from "containers/FrontierSliders/RunFrontier";
import ModelListContainer from "containers/Business/ModelList/ModelList";

export default class Blueprint extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { id } = this.props;

    console.log("blueprint wa", this.props);

    return <div>{"blueprint"}</div>;
  }
}
